import React, { useState } from 'react';
import { Link } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { Hidden } from '@material-ui/core';
import { FaInstagram, FaEnvelope, FaLinkedin } from 'react-icons/fa';
import i18n, { availableLanguages, storeLanguage } from '../../../i18n';
import { useStyles } from './styles';
import { faLogEvent } from '../../../services/firebase/analytics';

const Footer: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [language, setLanguage] = useState(i18n.language);
  const history = useHistory();

  const handleChangeLanguage = (lang: string): void => {
    i18n.changeLanguage(lang);
    setLanguage(lang);
    storeLanguage(lang);
    lang === 'en-US'
      ? faLogEvent('CHANGE_LANGUAGE_TO_ENGLISH')
      : faLogEvent('CHANGE_LANGUAGE_TO_PORTUGUESE');
  };

  const handleNavigateToWebsite = (event: any): void => {
    event.preventDefault();
    window.open('https://minerai.co', '_blank', 'noreferrer');
  };

  return (
    <Hidden smDown>
      <footer className={classes.footer}>
        <div className={classes.leftContent}>
          <button
            type="button"
            className={classes.button}
            onClick={event => handleNavigateToWebsite(event)}
          >
            {t('components:nav.about')}
          </button>
          <button
            type="button"
            className={classes.button}
            onClick={() => history.push('/dashboard/politica-de-privacidade')}
          >
            {t('components:nav.privacyPolicy')}
          </button>
          <button
            type="button"
            className={classes.button}
            onClick={() => history.push('/dashboard/central-de-ajuda')}
          >
            {t('components:nav.helpCenter')}
          </button>
        </div>
        <div className={classes.rightContent}>
          <div className={classes.languagesContainer}>
            {availableLanguages.map(lng => (
              <button
                key={lng.code}
                type="button"
                className={clsx(classes.button, {
                  [classes.selected]: language === lng.code,
                })}
                style={{ width: 100 }}
                onClick={() => handleChangeLanguage(lng.code)}
              >
                {lng.name}
              </button>
            ))}
          </div>
          <div className={classes.shareContainer}>
            <Link
              component="a"
              className={classes.link}
              rel="noreferrer"
              target="_blank"
              href="https://www.instagram.com/miner.ai/"
            >
              <FaInstagram size={19} className={classes.icon} />
            </Link>
            <Link
              component="a"
              className={classes.link}
              rel="noreferrer"
              target="_blank"
              href="https://www.linkedin.com/company/minerai"
            >
              <FaLinkedin size={19} className={classes.icon} />
            </Link>
            <Link
              component="a"
              className={classes.link}
              rel="noreferrer"
              href="mailto:contato@minerai.co"
            >
              <FaEnvelope size={19} className={classes.icon} />
            </Link>
          </div>
        </div>
      </footer>
    </Hidden>
  );
};

export default Footer;
